import * as cqs from '@/lib/cqs'
import * as commands from './commands'
import * as commandhandlers from './handlers/commandhandlers'
import * as queries from './queries'
import * as queryhandlers from './handlers/queryhandlers'

export var getCommandDispatcher = (t: ITrelloClient ,baseUrl: string) => {
    return new cqs.CompositeCommandDispatcher(t,baseUrl + "/trelloapi/c",true,true)
        .register(commands.SetupOnExistingIntegration.CqsDtoType,commandhandlers.SetupOnExistingIntegration)
        .register(commands.CreateSubscriptionFromTrelloLocale.CqsDtoType,commandhandlers.CreateSubscriptionFromTrelloLocaleHandler)
        .register(commands.UpdateSetup.CqsDtoType,commandhandlers.UpdateSetupHandler)
        .register(commands.DisablePowerUp.CqsDtoType, commandhandlers.DisablePowerUpHandler)
        .register(commands.SetPersonalAccessToken.CqsDtoType, commandhandlers.SetPersonalAccessTokenHandler)
}

export var getQueryExecutor = (t: ITrelloClient ,baseUrl: string) => {
    return new cqs.CompositeQueryExecutor(t,baseUrl + "/trelloapi/q",true,true)
    .register(queries.GetSetupQuery.CqsDtoType,queryhandlers.GetSetupQueryHandler)
    .register(queries.IsEmailAlreadyTakenQuery.CqsDtoType, queryhandlers.IsEmailAlreadyTakenQueryHandler)
}
